export default function calculatePages({
  container,
  items,
  children,
  pageWidth,
  pageHeight,
}) {
  const itemPages = [[]]
  const childPages = [[]]

  const gridEl = container.appendChild(
    createDiv(["grid", "auto-rows-auto", `grid-cols-${pageWidth}`])
  )

  for (let index = 0; index < items.length; index++) {
    const item = { ...items[index], gridIndex: index }
    const itemElement = createDiv([
      `col-span-${item.width}`,
      `row-span-${item.height}`,
    ])

    gridEl.appendChild(itemElement)

    if (getGridRowCount(gridEl) > pageHeight) {
      gridEl.replaceChildren(itemElement)
      itemPages.push([item])
      childPages.push([children.shift()])
    } else {
      itemPages[itemPages.length - 1].push(item)
      childPages[childPages.length - 1].push(children.shift())
    }
  }

  gridEl.remove()

  return [itemPages, childPages]
}

function createDiv(classes) {
  const el = document.createElement("div")
  el.classList.add(...classes)

  return el
}

function getGridRowCount(gridEl) {
  return window
    .getComputedStyle(gridEl)
    .getPropertyValue("grid-template-rows")
    .split(" ").length
}
